import React from 'react';
import { PHONE_NUMBER_WITH_PREFIX } from '../utils/constants';

const styles = {
    note: {
        background: '#fffbe6',
        border: '1px solid #ffe58f',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '18px',
        textAlign: 'center',
        fontSize: '18px',
        color: '#ad6800',
        fontWeight: 'bold',
        boxShadow: '0 2px 8px #ffe58f33'
    },
    navratri: {
        color: '#d48806'
    },
    callLink: {
        color: '#d48806',
        textDecoration: 'underline'
    }

}
const NavratriNote = () => (
  <div className='navratri-note' style={styles.note}>
    🌼 Food is available for <span style={styles.navratri}>Navratri</span>! Special Satvic meals prepared with care.<br />
    <a href={`tel:${PHONE_NUMBER_WITH_PREFIX}`} style={styles.callLink}>Order now</a> for your fasting days.<br />
  </div>
);

export default NavratriNote;
